import get from 'lodash.get';

const getCookieDomain = (rootState) => get(rootState, 'config.common.authtkt.cookie_domain');

export default getCookieDomain;
